import {
	COMPONENT_NAME as VALVE_MANAGE_COMPONENT_NAME,
	ValveManageComponent,
	ALZ_ACTION_COMPONENT_NAME,
	AlzActionComponent,
	AST_GSM_ACTION_COMPONENT_NAME,
	AstGsmActionComponent,
	ImmediatelyArchDateActionComponent,
	IMMEDIATELY_ARCH_DATE_ACTION_COMPONENT_NAME,
} from './action-run-dedicated/'
import { VALVE_MANAGE_SERVICE_NAME } from './action-run-dedicated/action-run-dedicated-valve-manage/services'
import { ValveManageService } from './action-run-dedicated/action-run-dedicated-valve-manage/services/valve-manage.service'
import { USER_SESSION_SERVICE_NAME, UserSessionService } from '../../../services/user-session'
import { GRID_SERVICE_NAME, GridService } from '../../../services/grid'
import { ALZ_ACTION_SERVICE_NAME } from './action-run-dedicated/action-run-dedicated-alz/services'
import { AlzActionService } from './action-run-dedicated/action-run-dedicated-alz/services/alz-action.service'

export const ACTION_RUN_MODULE_NAME = 'simax.common.action-run'

const module = angular.module(ACTION_RUN_MODULE_NAME, [])

module.component(VALVE_MANAGE_COMPONENT_NAME, new ValveManageComponent())
module.component(ALZ_ACTION_COMPONENT_NAME, new AlzActionComponent())
module.component(AST_GSM_ACTION_COMPONENT_NAME, new AstGsmActionComponent())
module.component(IMMEDIATELY_ARCH_DATE_ACTION_COMPONENT_NAME, new ImmediatelyArchDateActionComponent())

module.service(VALVE_MANAGE_SERVICE_NAME, [
	USER_SESSION_SERVICE_NAME,
	GRID_SERVICE_NAME,
	(userSessionService: UserSessionService, gridService: GridService) => new ValveManageService(userSessionService, gridService),
])

module.service(ALZ_ACTION_SERVICE_NAME, [USER_SESSION_SERVICE_NAME, (userSessionService: UserSessionService) => new AlzActionService(userSessionService)])
